import React, {useEffect} from "react";
import {indexGeoFence, indexWorkArea} from "./RainRoverConst";
import {Button} from "react-bootstrap";





function RoverFeatureSelector({paths, points, rainMap, onFeaturesSelected, showSaveButton} ) {

    const defaultGeoFenceId = paths.find(p => p.role === indexGeoFence)?.id;
    const defaultWorkAreaId = paths.find(p => p.role === indexWorkArea)?.id;
    const defaultReferenceLineId = paths.find(p => p.coords.length <= 10)?.id;
    const defaultWaterSourceIndex = 0;

    useEffect(() => {
        rainMap.setGeoFence(paths[defaultGeoFenceId]?.coords);
    }, [defaultGeoFenceId, paths, rainMap]);

    useEffect(() => {
        rainMap.setWorkArea(paths[defaultWorkAreaId]?.coords);
    }, [defaultWorkAreaId, paths, rainMap]);

    useEffect(() => {
        rainMap.setReferencePath(paths[defaultReferenceLineId]?.coords);
    }, [defaultReferenceLineId, paths, rainMap]);
    
    useEffect(() => {
        if (!rainMap.hasWaterSourcePos()) {
            rainMap.setWaterSourcePos(points[defaultWaterSourceIndex].coords);
        }
    }, [points, rainMap]);


    if (paths.length === 0) {
        return <></>;
    }
    
    return(
        <form>
            <table className={"table table-sm table-borderless"}>
                <tbody>
                <tr>
                    <td>Geo Fence</td>
                    <td>
                        <select className={"form-select form-select-sm"} name={"geofence"} aria-label={"Geo Fence Polygon"} defaultValue={defaultGeoFenceId}
                                // onChange={event => setMapFeature(rainMap.setGeoFence, event.target.value)}
                                onChange={event => {
                                    const index = parseInt(event.target.value);
                                    if (index >= 0) {
                                        rainMap.setGeoFence(paths[index].coords);
                                    } else {
                                        rainMap.setGeoFence(undefined);
                                    }
                                }}
                        >
                            <option key={-1} value={-1}>-- select --</option>
                            {paths.map(p => <option key={p.id} value={p.id}>[{p.name}]</option>)}
                        </select>
                    </td>
                </tr>

                <tr>
                    <td>Work Area</td>
                    <td>
                        <select className={"form-select form-select-sm"} name={"workarea"} aria-label={"Work Area Polygon"} defaultValue={defaultWorkAreaId}
                                onChange={event => {
                                    const index = parseInt(event.target.value);
                                    if (index >= 0) {
                                        rainMap.setWorkArea(paths[index].coords);
                                    } else {
                                        rainMap.setWorkArea(undefined);
                                    }
                                }}
                        >
                            <option key={-1} value={-1}>-- select --</option>
                            {paths.map(p => <option key={p.id} value={p.id}>[{p.name}]</option>)}
                        </select>
                    </td>
                </tr>

                <tr>
                    <td>AB Line</td>
                    <td>
                        <select className={"form-select form-select-sm"} name={"referenceline"} aria-label={"Reference AB Line"} defaultValue={defaultReferenceLineId}
                                onChange={event => {
                                    const index = parseInt(event.target.value);
                                    if (index >= 0) {
                                        rainMap.setReferencePath(paths[index].coords);
                                    } else {
                                        rainMap.setReferencePath(undefined);
                                    }
                                }}
                        >
                            <option key={-1} value={-1}>-- select --</option>
                            {paths.map(p => <option key={p.id} value={p.id}>[{p.name}]</option>)}
                        </select>
                    </td>
                </tr>

                <tr>
                    <td>Water Source</td>
                    <td>
                        <select className={"form-select form-select-sm"} aria-label={"Water Source Location"} defaultValue={defaultWaterSourceIndex}
                                onChange={event => {
                                    const pointId = parseInt(event.target.value);
                                    if (pointId >= 0) {
                                        rainMap.setWaterSourcePos(points[pointId].coords);
                                    } else {
                                        rainMap.setWaterSourcePos(undefined);
                                    }
                                }}
                        >
                            <option key={-1} value={-1}>None</option>
                            {points.map(point => {
                                return <option key={point.id} value={point.id}>
                                    Lat: {point.coords.lat} Lng: {point.coords.lng}
                                </option>
                            })}

                        </select>
                    </td>
                </tr>

                {showSaveButton
                    ? <tr>
                        <td>
                            <Button onClick={() => {
                                onFeaturesSelected();
                            }}>
                                Save
                            </Button>
                        </td>
                    </tr>
                    : null
                }

                </tbody>
            </table>
        </form>
    );
}


export default RoverFeatureSelector;